import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Header from './components/Header';
import OurStory from './components/OurStory';

import EventDetails from './components/EventDetails';
import Rsvp from './components/Rsvp';
import Registry from './components/Registry';
import LandingPage from './components/LandingPage';

import CashewAI from './components/CashewAI';
import AdminPage from './components/AdminPage';
import { Toaster } from 'react-hot-toast';

const AppContent: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';

  // Use useEffect to check localStorage after mount
  useEffect(() => {
    const storedAuth = localStorage.getItem('isAuthenticated');
    if (storedAuth === 'true') {
      setIsAuthenticated(true);
    }
  }, []); // Run once on mount

  const handleAuthenticate = () => {
    setIsAuthenticated(true);
    localStorage.setItem('isAuthenticated', 'true'); // Persist authentication
  };

  return (
    <div>
      <Toaster 
        toastOptions={{
          style: {
            background: '#f3ede6',
            color: '#615a4e',
          },
          success: {
            iconTheme: {
              primary: '#000',
              secondary: '#f3ede6',
            },
          },
        }}
      />
      {isAdminPage ? (
        <AdminPage />
      ) : !isAuthenticated ? (
        <LandingPage onAuthenticate={handleAuthenticate} />
      ) : (
        <>
          <Header />
          <div className="main-content">
            <Routes>
              <Route path="/" element={<Navigate to="/event-details" />} />
              <Route path="/event-details" element={<EventDetails />} />
              <Route path="/our-story" element={<OurStory />} />

              <Route path="/rsvp" element={<Rsvp />} />
              <Route path="/registry" element={<Registry />} />
              <Route path="/cashew-ai" element={<CashewAI />} />
            </Routes>
          </div>
        </>
      )}
    </div>
  );
};

export default AppContent;
